import React from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { init } from "@noriginmedia/norigin-spatial-navigation";
import { Menu } from "../layout/sidebar";
import CategoriesContent from "./content";

init({
  debug: false,
  visualDebug: false,
  rtl: true,
});

export default function SpitialOnlineCinema({ data }) {
  return (
    <div className="legacy-app-shell">
      <div className="legacy-app-shell-sidebar">
        <Menu focusKey="MENU" />
      </div>
      <div className="legacy-app-shell-content">
        <CategoriesContent data={data} />
      </div>
    </div>
  );
}

